import { useEffect, useReducer } from 'react'
import { reaction } from 'mobx'
import { useStore } from '@store/StoreProvider'

/** Читает operatorPresence store и перерисовывает при изменениях. */
export function useOperatorOwnPresence() {
  const { operatorPresence } = useStore()
  const [, bump] = useReducer((n: number) => n + 1, 0)

  useEffect(() => {
    return reaction(
      () => ({
        presence: operatorPresence.presence,
        loading: operatorPresence.loading,
        isOnBreak: operatorPresence.isOnBreak,
      }),
      () => bump(),
    )
  }, [operatorPresence])

  return operatorPresence
}
